import React from 'react';
import { AlertTriangle, ShieldCheck } from 'lucide-react';

export default function MedicalDisclaimer({ compact = false, className = '' }) {
    if (compact) {
        return (
            <div className={`flex items-center gap-1.5 text-[11px] text-slate-400 py-1.5 px-2.5 rounded-lg bg-slate-800/40 border border-slate-700/50 ${className}`}>
                <AlertTriangle className="w-3.5 h-3.5 text-amber-400 shrink-0" />
                <span>
                    <strong>Aviso informativo:</strong> Este análisis de rendimiento y carga fisiológica no constituye asesoramiento ni diagnóstico médico. Consulta a un profesional de la salud ante cualquier síntoma o anomalía.
                </span>
            </div>
        );
    }

    return (
        <aside 
            aria-label="Aviso legal y médico"
            className={`p-3.5 rounded-xl bg-slate-900/60 border border-slate-800 text-xs text-slate-400 flex items-start gap-3 shadow-inner ${className}`}
        >
            <div className="p-1.5 rounded-lg bg-amber-500/10 text-amber-400 shrink-0 mt-0.5">
                <AlertTriangle className="w-4 h-4" />
            </div>
            <div className="space-y-1">
                <p className="font-semibold text-slate-200">
                    Aviso Legal y Fisiológico de Rendimiento Deportivo
                </p>
                <p className="leading-relaxed">
                    Las métricas de predisposición (Readiness), análisis de recuperación, estimaciones de umbrales y prescripciones de entrenamiento generadas por esta plataforma están diseñadas exclusivamente con propósitos deportivos y de optimización del entrenamiento físico.
                </p>
                <p className="leading-relaxed text-[11px] text-slate-400">
                    No constituyen ni sustituyen el consejo, diagnóstico o tratamiento médico profesional. Ante cualquier síntoma anormal, dolor en el pecho, arritmia o duda sobre tu salud, suspende de inmediato el entrenamiento y consulta a un médico colegiado.
                </p>
            </div>
        </aside>
    );
}
